/**
 * BANK ACCOUNTS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getBankAccounts,
    getBankAccount,
    printBankAccount,
    createBankAccounts,
    updateBankAccounts,
    deleteBankAccounts,
} from "Core/configuration/bank_accounts/config/api.bank_accounts";

const state = {
    page: {},
    form: {},
    bank_accounts: [],
    selectedBankAccount: {
        account_id: null,
        company_id: "",
        bank_account_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        bank_account_details: [],
    },
    bank_accounts_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
        status: "1",
    },
    rules_bank_accounts: {
        account_id: {
            name: "account_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        account_number: {
            name: "account_number",
            rules: "trim|max_length[50]",
            max_len: "50",
            min_len: "",
            default_value: "",
        },
        account_name: {
            name: "account_name",
            rules: "trim|max_length[100]|required",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        bank_name: {
            name: "bank_name",
            rules: "trim|max_length[100]|required",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        branch_name: {
            name: "branch_name",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        account_type: {
            name: "account_type",
            rules: "trim|max_length[50]",
            max_len: "50",
            min_len: "",
            default_value: "",
        },
        routing_number: {
            name: "routing_number",
            rules: "trim|max_length[50]",
            max_len: "50",
            min_len: "",
            default_value: "",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        balance: {
            name: "balance",
            rules: "trim|max_length[11]|decimal",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        is_active: {
            name: "is_active",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
    },
};

// getters
const getters = {
    bank_accounts: (state) => {
        return state.bank_accounts;
    },
};

// actions
const actions = {
    async fetchBankAccounts({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getBankAccounts({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageBankAccounts", response.data.page);
                }

                commit("setBankAccounts", response.data.bank_accounts);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchBankAccount({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getBankAccount(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedBankAccount", response.data.bank_account);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printBankAccount({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printBankAccount(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveBankAccount({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["account_id"] === "undefined" || body["account_id"] == null || body["account_id"] == "") {
                delete body["account_id"];
                response = await createBankAccounts({ body: body, headers: config.headers });
            } else {
                let account_id = body["account_id"];
                delete body["account_id"];
                response = await updateBankAccounts({ body: body, headers: config.headers }, account_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteBankAccount({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteBankAccounts(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageBankAccounts(state, page) {
        state.page = page;
    },
    setBankAccounts(state, bank_accounts) {
        state.bank_accounts = bank_accounts;
    },
    setSelectedBankAccount(state, bank_account) {
        state.selectedBankAccount = bank_account;
    },
    resetSelectedBankAccount(state) {
        for (const key in state.selectedBankAccount) {
            if (key in state.rules_bank_accounts) {
                state.selectedBankAccount[key] = state.rules_bank_accounts[key].default_value == "null" ? null : state.rules_bank_accounts[key].default_value;
            }
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
